module.exports = __webpack_public_path__ + "img/physician3.527fb0da.svg";